import React from 'react'
import { Navigate } from 'react-router-dom'

const ProtectiveRoute = ({children}) => {
  
  // Add your own authentication on the below line.
  const isLoggedIn = localStorage.getItem('token') !== null ? localStorage.getItem('token') : false;
    if(!isLoggedIn){
        return <Navigate to={'/login'}/>
    }
  return children;
}

export default ProtectiveRoute